/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Workout_Rest_OverInputs */

const en_us2_workout_rest_over = /** @type {(inputs: Workout_Rest_OverInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Rest over. Time for the next set.`)
};

const pt_br2_workout_rest_over = /** @type {(inputs: Workout_Rest_OverInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Descanso terminado. Hora da próxima série.`)
};

const es_419_workout_rest_over = /** @type {(inputs: Workout_Rest_OverInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Terminó el descanso. Es hora de la siguiente serie.`)
};

const pt_pt2_workout_rest_over = /** @type {(inputs: Workout_Rest_OverInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Descanso terminado. Está na hora da próxima série.`)
};

const fr_fr2_workout_rest_over = /** @type {(inputs: Workout_Rest_OverInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Repos terminé. Place à la série suivante.`)
};

const de_de2_workout_rest_over = /** @type {(inputs: Workout_Rest_OverInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pause vorbei. Zeit für den nächsten Satz.`)
};

const it_it2_workout_rest_over = /** @type {(inputs: Workout_Rest_OverInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Recupero finito. Tocca alla prossima serie.`)
};

/**
* | output |
* | --- |
* | "Rest over. Time for the next set." |
*
* @param {Workout_Rest_OverInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const workout_rest_over = /** @type {((inputs?: Workout_Rest_OverInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Workout_Rest_OverInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_workout_rest_over(inputs)
	if (locale === "es-419") return es_419_workout_rest_over(inputs)
	if (locale === "pt-PT") return pt_pt2_workout_rest_over(inputs)
	if (locale === "fr-FR") return fr_fr2_workout_rest_over(inputs)
	if (locale === "de-DE") return de_de2_workout_rest_over(inputs)
	if (locale === "it-IT") return it_it2_workout_rest_over(inputs)
	return en_us2_workout_rest_over(inputs)
});
export { workout_rest_over as "workout.rest_over" }